module.exports = __webpack_public_path__ + "static/media/STOGI S TONEARM.96f44b91.png";